import React, { useEffect, useState } from "react";
import { getDropOffAnalytics } from "../../api/adminApi";
import EmptyStateCard from "../common/EmptyStateCard";
import { SkeletonTable } from "../common/SkeletonBlock";

function formatDateTime(value) {
  if (!value) return "-";

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  }).format(d);
}

export default function SignerDropOffTable() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      const res = await getDropOffAnalytics();
      setRows(res.data || []);
    } catch (e) {
      console.error("Failed to load drop-off analytics", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <SkeletonTable rows={5} cols={9} />;
  }

  return (
    <div className="card">
      {rows.length === 0 ? (
        <EmptyStateCard
          icon="🎉"
          title="No drop-offs found"
          message="That is a good sign. There are currently no signers who opened a document and then stalled before signing."
        />
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Signer</th>
                <th>Email</th>
                <th>Status</th>
                <th>Document</th>
                <th>First Viewed</th>
                <th>Last Active</th>
                <th>Views</th>
                <th>Last Invite</th>
                <th>Last Reminder</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.signerId}>
                  <td>{row.name}</td>
                  <td>{row.email}</td>
                  <td>
                    <span
                      className={`badge badge-${String(row.status).toLowerCase()}`}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td
                    style={{
                      maxWidth: "240px",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                    }}
                  >
                    {row.documentName}
                  </td>
                  <td>{formatDateTime(row.firstViewedAt)}</td>
                  <td>{formatDateTime(row.lastActiveAt)}</td>
                  <td>{row.viewCount ?? 0}</td>
                  <td>{formatDateTime(row.lastInviteSentAt)}</td>
                  <td
                    style={
                      row.lastReminderSentAt
                        ? {
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            verticalAlign: "middle",
                          }
                        : {
                            verticalAlign: "middle",
                            textAlign: "center",
                          }
                    }
                  >
                    {formatDateTime(row.lastReminderSentAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
